import React from "react";

const OrangeButton = ({ text, clickEvent }) => {
  return (
    <button 
      onClick={() => clickEvent()}
      className="w-[calc(100%-46px)] min-h-[60px] md:min-h-[67px] text-white rounded-lg max-w-[600px] mx-auto bg-[#FFAF58] text-center font-semibold whitespace-pre-line text-[15px] md:text-[19px] leading-[20px] md:leading-[24px] tracking-[0%] align-middle"
    >
      {text}
    </button>
  );
};

export default OrangeButton;
